/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { GridFilterDialogViewModelGroupingLevel } from "./GridFilterDialogViewModelGroupingLevel";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridFilterDialogViewModelGroupingLevelCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridFilterDialogViewModelGroupingLevelCollection, _super);
    function GridFilterDialogViewModelGroupingLevelCollection() {
        return _super.call(this, GridFilterDialogViewModelGroupingLevel.$, 0) || this;
    }
    GridFilterDialogViewModelGroupingLevelCollection.$t = markType(GridFilterDialogViewModelGroupingLevelCollection, 'GridFilterDialogViewModelGroupingLevelCollection', ObservableCollection$1.$.specialize(GridFilterDialogViewModelGroupingLevel.$));
    return GridFilterDialogViewModelGroupingLevelCollection;
}(ObservableCollection$1));
export { GridFilterDialogViewModelGroupingLevelCollection };
//# sourceMappingURL=GridFilterDialogViewModelGroupingLevelCollection.js.map
